import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

export default function block_galleries() {
  if ($('.felds-galleries-block').length == 0) return;

  $('.felds-galleries-block .block-filter #filter-year').select2();

  $('.felds-galleries-block .block-filter #filter-year').on('select2:select', function (e) {
    var params = '';

    var filter_year = $('.felds-galleries-block .block-filter #filter-year').val();
    if (filter_year) {
      params = '?filter_year=' + filter_year;
    }

    location = $('.felds-galleries-block .block-filter').data('url') + params;
  });

  const dynamicGallery = lightGallery($('.felds-galleries-block')[0], {
    download: false,
    allowMediaOverlap: true,
    toggleThumb: true,
    plugins: [lgThumbnail],
    prevHtml: '<i class="far fa-angle-left"></i>',
    nextHtml: '<i class="far fa-angle-right"></i>',
    dynamic: true,
  });

  $('.felds-galleries-block .block-content .item a').click(function(e){
    e.preventDefault();

    var _instance = this;
    $(this).find('.item-image').append('<div class="loading"></div>');

    $.ajax({
      url: $(this).attr('href'),
      dataType: 'JSON',
      success: function(res) {
        $(_instance).find('.loading').remove();

        dynamicGallery.refresh(res);
        
        dynamicGallery.openGallery(0);
      }
    });
  });
}
